import { useState, useEffect } from 'react';

export const Footer = () => {
  const [time, setTime] = useState('--:--:--');

  useEffect(() => {
    const tick = () => {
      try {
        const str = new Date().toLocaleTimeString('en-GB', {
          timeZone: 'Asia/Jakarta',
          hour12: false,
        });
        setTime(str);
      } catch (_) {}
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer className="footer">
      <div className="foot">
        <span>© 2026 ALIF GARINDRA</span>
        <span className="foot-dot">●</span>
        <span>HAND-CODED &amp; OVER-ANIMATED</span>
        <span className="foot-dot">●</span>
        <span id="footClock">{time}</span>
      </div>
    </footer>
  );
};
